import React from "react";

import styles from "./stepHeader.scss";
import { buildBaseUrl } from "../../../services";
import HeaderLogo from "../../../components/HeaderLogo";

const StepHeader = ({ title, rightButton, leftButton }) => (
  <div className={styles.header}>
    {leftButton && <div className={styles.leftButton}>{leftButton}</div>}
    {title ? (
      <div className={styles.title}>{title}</div>
    ) : (
      <HeaderLogo
        className={styles.logo}
        onClick={() => {
          window.location.href = buildBaseUrl("");
        }}
      />
    )}
    {rightButton && <div className={styles.rightButton}>{rightButton}</div>}
  </div>
);

StepHeader.defaultProps = {
  rightButton: null,
  leftButton: null,
  title: ""
};

export default StepHeader;



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/StepHeader/index.tsx